export default __webpack_public_path__ + "static/media/Icon wrap.46028c39.svg";